import { render, staticRenderFns } from "./comp_Hook-ProductPage-ContactLensDescription.vue?vue&type=template&id=7a2e0ccd&scoped=true&"
import script from "./comp_Hook-ProductPage-ContactLensDescription.vue?vue&type=script&lang=js&"
export * from "./comp_Hook-ProductPage-ContactLensDescription.vue?vue&type=script&lang=js&"
import style0 from "./comp_Hook-ProductPage-ContactLensDescription.vue?vue&type=style&index=0&id=7a2e0ccd&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a2e0ccd",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib/components/VDivider';
installComponents(component, {VDivider})
